import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toNumber',
  standalone: true
})
export class ToNumberPipe implements PipeTransform {

  transform(value: number | null | undefined, ...args: unknown[]): unknown {
    return (value === null || value === undefined) ? '' : ToNumberPipe.toNumber(value);
  }

  static toNumber(val: number): string {
    return new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(val);
  }
}
